import ActiveQuoteRootPage from "~/features/cart/activeQuote/components/ActiveQuotePage/ActiveQuotePage";

export function create() {
  return <ActiveQuoteRootPage />;
}
